import React from 'react';

// icons
import CircleCheckIcon from '../../../../icons/CircleCheckIcon';
import CommentIcon from '../../../../icons/CommentIcon';
import DeadlineIcon from '../../../../icons/DeadlineIcon';
import PencilIcon from '../../../../icons/PencilIcon';
import TaskAssignedIcon from '../../../../icons/TaskAssignedIcon';
import UserPlusIcon from '../../../../icons/UserPlusIcon';

// constants
import { ACTIVITY_TYPES } from '../../constants';

/**
 * Leading circle of an activity card. Personal events show the actor's initials
 * (or picture); everything else shows the icon of its activity type.
 */
const TYPE_ICONS = {
    [ACTIVITY_TYPES.COMMENTS]: CommentIcon,
    [ACTIVITY_TYPES.CUE_UPDATED]: PencilIcon,
    [ACTIVITY_TYPES.CUE_ASSIGNED]: TaskAssignedIcon,
    [ACTIVITY_TYPES.CUE_COMPLETED]: CircleCheckIcon,
    [ACTIVITY_TYPES.TEAM_INVITED]: UserPlusIcon,
    [ACTIVITY_TYPES.TEAM_JOINED]: UserPlusIcon,
    [ACTIVITY_TYPES.DEADLINE]: DeadlineIcon,
};

const ActivityAvatar = ({ type, actor, showIcon }) => {
    const useIcon = showIcon || !actor;

    if (!useIcon) {
        return (
            <div className="activityAvatar activityAvatar--initials">
                {actor.avatarUrl
                    ? <img src={actor.avatarUrl} alt={actor.name}/>
                    : <span>{actor.initials}</span>}
            </div>
        )
    }

    const Icon = TYPE_ICONS[type] || CommentIcon;

    return (
        <div className={`activityAvatar activityAvatar--icon activityAvatar--${type}`}>
            <Icon size={16}/>
        </div>
    )
}

export default ActivityAvatar;
